import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addSalaryComponentHr = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Salary Component',
    body
  );
  return data;
});
export const updateSalaryComponentHr = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Salary Component/${id}`,
    body
  );
  return data;
});

export const getSalaryComponentHr = catchAsync(async () => {
  // ["salary_component_abbr","statistical_component","depends_on_payment_days","exempted_from_income_tax","is_tax_applicable","is_flexible_benefit","variable_based_on_taxable_salary"]
  const { data } = await axiosInstance.get(
    '/api/resource/Salary Component?fields=["name","amount","formula","condition","exempted_from_income_tax","depends_on_payment_days","statistical_component","is_tax_applicable","is_flexible_benefit","variable_based_on_taxable_salary","salary_component_abbr","salary_component","type","disabled"]'
  );
  return data;
});
export const deleteSalaryComponentHr = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Salary Component/${id}`
  );
  return data;
});
export const getSalaryComponentHrDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Salary Component/${id}`
  );
  return data;
});
